import { createFileRoute } from "@tanstack/react-router";
import Camioane from "@/pages/Camioane";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/lkw/")({
  head: () => routeHead("/de/lkw/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Camioane />
  );
}
